export default __webpack_public_path__ + "static/media/frame.8d661474.png";